module.exports = __webpack_public_path__ + "img/web2.f7381546.png";